import { type NavDeviceType, type NavItemType } from '@/defs/nav'

export const filterNavItems = (items: NavItemType[], device: NavDeviceType): NavItemType[] =>
  items
    .filter(({ only }) => !only || only === device)
    .map((item) => {
      if (!item.submenu) return item
      const submenu = filterNavItems(item.submenu, device)
      return { ...item, submenu: submenu.length ? submenu : undefined }
    })
